import { SubMenuList } from '../sub-menu-list';

export class DuplicateCheckerButton extends SubMenuList {
  name = 'duplicate-checker';
}
